import React, { useCallback } from 'react';
import { NavigationWrapper } from '../styles';
import { useHistory } from 'react-router-dom';
import BottomNavigationItem from './bottomNavigationItem';
import useKeyboardVisibility from '../../../global/useKeyboard';

interface Props {
  isApplySubNavSpace?: boolean;
  backNavigationPath?: string;
  rightElement?: React.ReactNode;
  handleBackIcon?: () => void;
}

const BottomSubNavigation: React.FC<Props> = ({
  isApplySubNavSpace,
  backNavigationPath,
  rightElement,
  handleBackIcon
}) => {
  //Other variables
  const history = useHistory();
  const isKeyboardVisible = useKeyboardVisibility();

  const onClickBackIcon = useCallback(() => {
    if (handleBackIcon) {
      handleBackIcon();
    } else if (backNavigationPath) {
      history.push(backNavigationPath);
    } else if (history.length > 1) {
      history.goBack();
    } else {
      history.push('/');
    }
  }, [handleBackIcon, backNavigationPath, history]);

  if (isKeyboardVisible) {
    return null;
  }

  return (
    <>
      <NavigationWrapper isApplySubNavSpace={isApplySubNavSpace}>
        <BottomNavigationItem iconName='back-navigation-arrow' onClick={onClickBackIcon} />
        {rightElement && rightElement}
      </NavigationWrapper>
    </>
  );
};

export default BottomSubNavigation;
